import { booleanAttribute, Component, EventEmitter, inject, Input, Output, ChangeDetectionStrategy } from '@angular/core';
import { LetDirective } from '@ngrx/component';
import { Store } from '@ngrx/store';

import { NtyDetailFooterComponent } from '@ninety/mobile/platform/components';
import { LanguageSelectors } from '@ninety/mobile/platform/state';

@Component({
  selector: 'nty-discussion-detail-footer',
  imports: [NtyDetailFooterComponent, LetDirective],
  changeDetection: ChangeDetectionStrategy.Eager,
  template: `
    <ng-container *ngrxLet="vm$ as vm">
      <nty-detail-footer
        [itemType]="vm.language.item"
        [isEditing]="isEditing"
        [disableSave]="disableSave"
        [disableEdit]="disableEdit"
        (add)="universalCreateOpened.emit()"
        (edit)="edit.emit()"
        (revert)="revert.emit()"
        (save)="save.emit()"
        (delete)="delete.emit()" />
    </ng-container>
  `,
})
export class DiscussionDetailFooterComponent {
  @Input({ transform: booleanAttribute }) isEditing = false;
  @Input({ transform: booleanAttribute }) disableSave = false;
  @Input({ transform: booleanAttribute }) disableEdit = false;

  @Output() universalCreateOpened = new EventEmitter<void>();
  @Output() edit = new EventEmitter<void>();
  @Output() revert = new EventEmitter<void>();
  @Output() save = new EventEmitter<void>();
  @Output() delete = new EventEmitter<void>();

  private readonly store = inject(Store);

  vm$ = {
    language: this.store.select(LanguageSelectors.discussionLanguage),
  };
}
